import { FC, ReactElement } from 'react';

import { Page, Wrapper } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet, ConnectedRegistrationForm } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './RegistrationPage.scss';

interface RegistrationPageProps {
    className?: string;
}

export const RegistrationPage: FC<RegistrationPageProps> = ({
    className = '',
}): ReactElement => (
    <Page className={`registration-page ${className}`}>
        <ConnectedPageHelmet appRoute={AppRoute.registration} />

        <Wrapper className="registration-page__wrapper">
            <ConnectedRegistrationForm className="registration-page__registration-form" />
        </Wrapper>

        <ConnectedBlockRenderer appRoute={AppRoute.registration} className="registration-page__section" />
    </Page>
);
